import i18n from '@/lib/i18n/client';
import { DEFAULT_LANGUAGE_KEY } from '@/lib/i18n/constants';

String.prototype.toAppLocaleUpperCase = function () {
  const locale = i18n.language || DEFAULT_LANGUAGE_KEY;

  return this.toLocaleUpperCase(locale);
};
